export const OFFER_CANCELLED_PARAM = 'offer-cancelled';
